import * as actionCreatorFactory from "typescript-fsa";
import { Action } from "typescript-fsa";

import { StateError, NormalisedResult, PaginationResult } from "@orm/models";
import * as actionTypes from "../constants";
import { Report, ReportsNormalisedEntities } from "../models";

export type ReportsResult = NormalisedResult<number[], ReportsNormalisedEntities>;

const actionCreator = actionCreatorFactory.default();

export const requestReportsIndex = actionCreator<{}>(actionTypes.INDEX_REQUEST);
export const reportsIndexSuccess = actionCreator<[PaginationResult, ReportsResult]>(
    actionTypes.INDEX_SUCCESS,
);
export const reportsIndexFailure = actionCreator<StateError>(actionTypes.INDEX_FAILURE);

export const requestReportsStore = actionCreator<Report>(actionTypes.STORE_REQUEST);
export const reportsStoreSuccess = actionCreator<Report>(actionTypes.STORE_SUCCESS);
export const reportsStoreFailure = actionCreator<StateError>(actionTypes.STORE_FAILURE);

export const requestReportsShow = actionCreator<number>(actionTypes.SHOW_REQUEST);
export const reportsShowSuccess
    = actionCreator<NormalisedResult<number, ReportsNormalisedEntities>>(actionTypes.SHOW_SUCCESS);
export const reportsShowFailure = actionCreator<StateError>(actionTypes.SHOW_FAILURE);

export const requestReportsUpdate = actionCreator<Report>(actionTypes.UPDATE_REQUEST);
export const reportsUpdateSuccess = actionCreator<{}>(actionTypes.UPDATE_SUCCESS);
export const reportsUpdateFailure = actionCreator<StateError>(actionTypes.UPDATE_FAILURE);

export const requestReportsDestroy = actionCreator<number>(actionTypes.DESTROY_REQUEST);
export const reportsDestroySuccess = actionCreator<{}>(actionTypes.DESTROY_SUCCESS);
export const reportsDestroyFailure = actionCreator<StateError>(actionTypes.DESTROY_FAILURE);

export const requestReportTypesIndex = actionCreator<{}>(actionTypes.REPORT_TYPES_INDEX_REQUEST);
export const reportTypesIndexSuccess
    = actionCreator<NormalisedResult<number[], ReportsNormalisedEntities>>(actionTypes.REPORT_TYPES_INDEX_SUCCESS);
export const reportTypesIndexFailure = actionCreator<StateError>(actionTypes.REPORT_TYPES_INDEX_FAILURE);

export type ReportsAction = Action<{}> | Action<number> | Action<Report> |
    Action<NormalisedResult<number, ReportsNormalisedEntities>> |
    Action<NormalisedResult<number[], ReportsNormalisedEntities>> |
    Action<StateError>;
